class SourceUpdatesBreakdownRow {
    constructor(
        public label: string = "",
        public sourceId?: string,
        public sourceName?: string,
        public sourceType?: string,
        public organizationId?: string,
        public organizationName?: string,
        public newItemCount: number = 0,
        public jsonDataChangedItemCount: number = 0,
        public attributesChangedItemCount: number = 0,
        public recentAttributesChangedItemCount: number = 0,
        public affectedItemCount: number = 0
    ) {
        //
    }

    public static fromPOJO(data: any) {
        return new SourceUpdatesBreakdownRow(
            data?.label ?? "",
            data?.sourceId,
            data?.sourceName,
            data?.sourceType,
            data?.organizationId,
            data?.organizationName,
            data?.newItemCount ?? 0,
            data?.jsonDataChangedItemCount ?? 0,
            data?.attributesChangedItemCount ?? 0,
            data?.recentAttributesChangedItemCount ?? 0,
            data?.affectedItemCount ?? 0
        );
    }
}

export default SourceUpdatesBreakdownRow;
